import DatetimeUtils from "../../../gd/utils/datetime-utils"
import ApiChatV2 from "../../../gd/api/chat-new"
import isSameValue from "../../../gd/utils/misc/is-same-value"
import Reactions from "../../reaction/reactions"

const debug = false
// const debug = "ChatMessage"

export default class ChatMessage {

    public id                   : ID
    public chatId               : ID
    public attachments          : any
    public isNew                : boolean
    public message              : string
    public messageRTF           : any
    public metaData             : any
    public momentCreated        : Moment //| null
    public systemType           : number
    public userId               : ID
    public tempId               : ID
    public reactions            : Reactions


    constructor(data: any) {

        this.id                 = data['id']
        this.chatId             = data['chatId']
        this.attachments        = data['attachments']
        this.isNew              = data['isNew']
        this.message            = data['message']
        this.messageRTF         = data['messageRTF']
        this.metaData           = data['metaData']
        this.momentCreated      = data['momentCreated'] ? DatetimeUtils.datetimeToMoment(data['momentCreated']) : moment()
        this.systemType         = data['systemType']
        this.userId             = data['userId']
        this.tempId             = data['tempId']
        this.reactions          = Reactions.initFromJson(data['reactions'])


        return this
    }

    applyDelta(data:any) {
        debug && console.log(debug, "applyDelta()", data)

        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return

            // @ts-ignore
            debug && console.log(debug, "applyDelta key=", key, !isSameValue(key, value), this[key], value)

            if (!isSameValue(this, key, value)) {

                debug && console.log(".....set", key, "neValue", value)

                switch (key) {
                    case 'reactions':
                        // @ts-ignore
                        this[key] = Reactions.initFromJson(value); break

                    default         :
                        // @ts-ignore
                        this[key] = value
                }

                isChanged = true
            }
        })

        debug && console.log(debug, "....applyDelta isChanged", isChanged)

        return isChanged
    }

    toggleReaction(reactionType: number) {
        debug && console.log(debug, "toggleReaction", reactionType)

        if(this.reactions.isMyReaction(reactionType)) {
            ApiChatV2.reactionDelete(this.chatId, this.id, reactionType)
        } else {
            ApiChatV2.reactionAdd(this.chatId, this.id, reactionType)
        }

        gd.bus.triggerEvent("message-reaction:change")
    }

    toJSON() {
        throw Error("Not implemented")
    }
}